module.exports = "/images/CIRUS-1.svg";